import { KeyboardEvent, useContext, useState } from "react";
import ValoresInputContext from "./context/FiltrosInputContext";
import Select from 'react-select'


export default function BotonesOrdenamiento(props: botonesOrdenamientoProps) {  
    const [titulo, setTitulo] = useState("");
    const [autor, setAutor] = useState("");
    const [palabraClave, setPalabraClave] = useState("");  
    const [ISBN, setISBN] = useState("");  
    const [coleccion, setColeccion] = useState("");   
    const [valorTipo, setValorTipo] = useState(props.listaOPanel) 
    const [labelTipo, setLabelTipo] = useState('lista') 
    const inputTexto = useContext<any>(ValoresInputContext)
    const Filtros = (e: KeyboardEvent<HTMLInputElement>, tipo:number) =>{ 
        switch (tipo) {
            case 3:
                setISBN(e.currentTarget.value)
            break; 
        }          
    }         
    const onFiltrosButton = () =>{ props.getFiltros({titulo, autor, palabraClave, ISBN, coleccion})}
    const onFiltrosChange = () =>{ props.getFiltros({titulo:localStorage.getItem('fil_titulo'), autor:localStorage.getItem('fil_autor'), palabraClave:localStorage.getItem('fil_palabraClave'), ISBN, coleccion:localStorage.getItem('fil_coleccion')})}
    const orden = (tipo:number) =>props.ordenamiento(tipo) 
    const cambiaVista = (id:number) =>{
        setValorTipo((id===1)?2:1)
        setLabelTipo((id===1)?'panel':'listado')
        props.asignaVisualizacion((id===1)?2:1)        
    } 
    const asignaValor = async(e:any, tipo:number, name:string) =>{
        switch (tipo) {
            case 0:
                setTitulo(e.value)
            break;
            case 1:
                setAutor(e.value)
            break;
            case 2:
                setPalabraClave(e.value)
            break;
            case 3:
                setColeccion(e.value)
            break; 
            }
            localStorage.setItem(name,e.value)
        return;
    }  
    const resetFiltros = async() =>{
        localStorage.setItem('fil_titulo','') 
        localStorage.setItem('fil_palabraClave','') 
        localStorage.setItem('fil_autor','') 
        localStorage.setItem('fil_coleccion','')  
        setISBN('') 
        onFiltrosButton();             
        return;
    }

      const titulos =(props.predictivos.Table)     
      const autores = (props.predictivos.Table1)
      const colecciones = (props.predictivos.Table2)
      const palabrasClave = (props.predictivos.Table3)
    if(valorTipo===1){
    return(
        <>
            <button className="btn_order d-inline-block d-sm-none me-1" onClick={() => orden(1)}>Ordenar por año de edición</button>
            <button className="btn_order d-inline-block d-sm-none ms-1" onClick={() => orden(2)}>Ordenar alfábeticamente</button>
            <button className="ms-1 btn_order d-none d-sm-inline-block  separacionBoton" onClick={() => orden(1)}>Ordenar por año de edición <i className="fa fa-sort" aria-hidden="true"></i></button>
            <button className="ms-1 btn_order d-none d-sm-inline-block separacionBoton" onClick={() => orden(2)}>Ordenar alfábeticamente</button>
            <Select options={titulos} onChange={ (e)=>{asignaValor(e, 0,'fil_titulo').then(onFiltrosChange)} } className="mt-5" placeholder="Título" />
            <Select options={autores} onChange={(e)=>asignaValor(e, 1,'fil_autor').then(onFiltrosChange)} className="mt-3" placeholder="Autor" />
            <Select options={palabrasClave} onChange={(e)=>{asignaValor(e, 2,'fil_palabraClave').then(onFiltrosChange)}} className="mt-3" placeholder="Palabra clave" />            
            <form action="" onSubmit={e => { e.preventDefault(); onFiltrosButton(); }}>
            <input onKeyUp={(e)=>Filtros(e,3)} defaultValue={inputTexto.ISBN} onChange={e => ISBN} type="text" className="form-control mt-3" maxLength={50}/>ISBN<br/>
            {/* <input onKeyUp={(e)=>Filtros(e,4)} defaultValue={inputTexto.coleccion} onChange={e => coleccion} type="text" className="form-control mt-3" maxLength={50}/>Colección1<br/> */}
            <Select options={colecciones} onChange={(e)=>asignaValor(e, 3,'fil_coleccion').then(onFiltrosChange)} className="mt-3" placeholder="Colección" />
            
            <button type="button" className="ms-1 btn btn-warning btn-lg separacionBoton"  onClick={()=>resetFiltros()} >Limpiar <i className="fa fa-eraser fa-fw" aria-hidden="true"></i></button>
            <button type="submit" className="ms-1 btn btn-primary btn-lg separacionBoton" >Filtrar <i className="fa fa-filter" aria-hidden="true"></i></button><br/>
            </form>
            <button className="ms-1 btn_order separacionBoton mt-4" onClick={()=>cambiaVista(valorTipo)}>Ver {labelTipo} <i className="fa fa-list-alt" aria-hidden="true"></i></button>
        </>
    )
    }else{
        return(
        <>
            <button className="ms-1 btn_order separacionBoton" onClick={() => orden(1)}>Ordenar por año de edición</button>
            <button className="ms-1 btn_order separacionBoton" onClick={() => orden(2)}>Ordenar alfábeticamente</button>
            <button className="ms-1 btn_order btn-lg d-none d-sm-inline-block separacionBoton mt-4" onClick={()=>cambiaVista(valorTipo)}>Ver {labelTipo} <i className="fa fa-th-large" aria-hidden="true"></i></button>
        </>
        )
    }
}

interface botonesOrdenamientoProps{
    ordenamiento(orden:number):void,
    getFiltros(filtro:any):void,
    asignaVisualizacion(visualiza:number):void,
    listaOPanel:number,    
    predictivos:any
}